export enum AlternativeCurrenciesTypes {
  VacationCash = 'vc',
  Points = 'points',
  DBC = 'dbc',
  Loyalty = 'loyalty'
}
